import React from "react";

export const MinusCircle = ({ color = "#706A85" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_51_4468)">
        <rect width="16" height="16" rx="8" fill="currentColor" />
        <path d="M12 7.33337H4V8.66671H12V7.33337Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_51_4468">
          <rect width="16" height="16" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
